/* ============================================================
   IMENHOF BLOOM — product.js
   Productpagina-gedrag: galerij (klik + swipe), variantkiezer
   (prijs/knop/URL/afbeelding) en sticky koopbalk (mobiel).
   Wordt alleen op de productpagina geladen (main-product.liquid).
   Zelfstandig: eigen money-helper, geen afhankelijkheid van theme.js.
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => window.Shopify && Shopify.formatMoney
    ? Shopify.formatMoney(cents, window.themeMoneyFormat)
    : '€' + (cents / 100).toFixed(2).replace('.', ',');
  const initialVariantParameter = new URL(window.location.href).searchParams.get('variant');

  function setButtonText(button, label) {
    if (!button) return;
    button.textContent = label;
    const productTitle = button.dataset.productTitle || '';
    button.setAttribute('aria-label', productTitle ? label + ' — ' + productTitle : label);
  }

  /* ============================================================
     GALERIJ
     ============================================================ */
  function galleryActivate(g, idx) {
    const slides = g.querySelectorAll('.gallery__slide');
    const thumbs = g.querySelectorAll('.gallery__thumb');
    slides.forEach((s, i) => {
      const active = i === idx;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
      s.toggleAttribute('inert', !active);
    });
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
  }
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    g.addEventListener('click', (e) => {
      const thumb = e.target.closest('.gallery__thumb');
      if (!thumb) return;
      const thumbs = Array.from(g.querySelectorAll('.gallery__thumb'));
      const idx = thumbs.indexOf(thumb);
      if (idx > -1) galleryActivate(g, idx);
    });

    const initialSlides = Array.from(g.querySelectorAll('.gallery__slide'));
    const initialIndex = initialSlides.findIndex((slide) => slide.classList.contains('is-active'));
    if (initialSlides.length) galleryActivate(g, initialIndex > -1 ? initialIndex : 0);

    /* Swipe op touch */
    const main = g.querySelector('.gallery__main');
    const slideCount = g.querySelectorAll('.gallery__slide').length;
    if (!main || slideCount < 2) return;
    let startX = 0, startY = 0;
    main.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      const slides = Array.from(g.querySelectorAll('.gallery__slide'));
      const cur = slides.findIndex((s) => s.classList.contains('is-active'));
      const next = dx < 0 ? cur + 1 : cur - 1;
      if (next < 0 || next >= slides.length) return;
      galleryActivate(g, next);
    }, { passive: true });
  });

  /* ============================================================
     VARIANTKIEZER
     ============================================================ */
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('section');
    if (!section) return;
    const form = section.querySelector('[data-product-form]');
    const variantsJson = picker.querySelector('[data-variants-json]');
    if (!form || !variantsJson) return;
    const data = JSON.parse(variantsJson.textContent);
    const idInput = form.querySelector('[name="id"]');
    const priceEls = section.querySelectorAll('[data-price]');
    const addBtn = form.querySelector('[type=submit]');
    const barBtn = section.querySelector('[data-buybar-add]');
    const gallery = section.querySelector('[data-gallery]');

    function currentOptions() {
      return Array.from(picker.querySelectorAll('input:checked')).map((i) => i.value);
    }
    function findVariant(opts) {
      return data.find((v) => v.options.every((o, idx) => o === opts[idx]));
    }
    function setButtons(disabled, label, price) {
      const submitting = form.dataset.submitting === 'true';
      if (addBtn) {
        addBtn.disabled = submitting || disabled;
        const mainLabel = !submitting && !disabled && price != null ? label + ' — ' + money(price) : label;
        setButtonText(addBtn, submitting ? 'Bezig…' : mainLabel);
      }
      if (barBtn) {
        barBtn.dataset.variantAvailable = String(!disabled);
        barBtn.disabled = submitting || disabled;
        setButtonText(barBtn, submitting ? 'Bezig…' : label);
      }
    }
    function update(reflectInUrl) {
      const opts = currentOptions();
      const variant = findVariant(opts);
      // update label readouts
      picker.querySelectorAll('[data-option-value]').forEach((el) => {
        const grp = el.closest('.variant-group');
        const checked = grp.querySelector('input:checked');
        if (checked) el.textContent = checked.value;
      });
      if (!variant) {
        setButtons(true, 'Niet beschikbaar');
        return;
      }
      idInput.value = variant.id;
      let html = '<span class="price--current">' + money(variant.price) + '</span>';
      if (variant.compare_at_price > variant.price) {
        html += ' <span class="price--compare">' + money(variant.compare_at_price) + '</span>';
      }
      priceEls.forEach((el) => { el.innerHTML = html; });
      const label = variant.available ? (addBtn && addBtn.dataset.addLabel) || 'In winkelwagen' : 'Tijdelijk uitverkocht';
      setButtons(!variant.available, label, variant.price);
      if (variant.featured_media && gallery) {
        const mid = String(variant.featured_media.id);
        const thumb = gallery.querySelector('.gallery__thumb[data-media-id="' + mid + '"]');
        if (thumb) thumb.click();
      }
      // reflect in URL
      if (reflectInUrl && history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    picker.addEventListener('change', (event) => update(event.isTrusted));
    window.addEventListener('imenhof:product-submit-state', (event) => {
      if (event.detail && event.detail.form === form) update(false);
    });
    update(false);
  });

  /* ============================================================
     VASTE MOBIELE KOOPBALK
     ============================================================ */
  const productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    const purchaseColumn = productSection.querySelector('.product__purchase-column');
    const productForm = productSection.querySelector('[data-product-form]');
    const originalAdd = productForm && productForm.querySelector('[type="submit"]');
    const mobileBuybar = productSection.querySelector('[data-mobile-buybar]');
    const buybarAdd = mobileBuybar && mobileBuybar.querySelector('[data-buybar-add]');
    const variantPicker = productSection.querySelector('[data-variant-picker]');
    const adviceBar = document.getElementById('pw-plak');
    const advicePanel = document.querySelector('#plantwijzer .uitkomst');
    const mobileQuery = window.matchMedia('(max-width: 900px)');
    const root = document.documentElement;
    const productPurchasable = productSection.dataset.productPurchasable === 'true';
    const giftCard = productSection.dataset.productGiftCard === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const initialVariantInput = productForm && productForm.querySelector('[name="id"]');
    let variantExplicit = !variantPicker || Boolean(
      initialVariantParameter && initialVariantInput && initialVariantInput.value === initialVariantParameter
    );
    let adviceDismissed = false;
    let measureQueued = false;

    function measurePurchaseSticky() {
      if (!purchaseColumn) return;
      const rootStyle = window.getComputedStyle(document.documentElement);
      const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-h')) || 0;
      const availableHeight = window.innerHeight - headerHeight - 40;
      const canStick = window.matchMedia('(min-width: 901px)').matches && purchaseColumn.scrollHeight <= availableHeight;
      purchaseColumn.dataset.purchaseSticky = canStick ? 'true' : 'false';
    }

    if (purchaseColumn) {
      const purchaseObserver = new ResizeObserver(measurePurchaseSticky);
      purchaseObserver.observe(purchaseColumn);
      window.addEventListener('resize', measurePurchaseSticky, { passive: true });
      measurePurchaseSticky();
    }

    function variantAvailable() {
      return Boolean(buybarAdd) && buybarAdd.dataset.variantAvailable !== 'false';
    }

    function setAccessible(element, show) {
      if (!element) return;
      element.setAttribute('aria-hidden', show ? 'false' : 'true');
      element.toggleAttribute('inert', !show);
    }

    function setBuybarMode(state) {
      if (!buybarAdd) return;
      if (productForm && productForm.dataset.submitting === 'true') {
        buybarAdd.disabled = true;
        buybarAdd.setAttribute('aria-disabled', 'true');
        setButtonText(buybarAdd, 'Bezig…');
        return;
      }
      const available = variantAvailable();
      const addLabel = buybarAdd.dataset.addLabel || 'In winkelwagen';
      const chooseLabel = buybarAdd.dataset.chooseLabel || 'Kies uitvoering';
      const soldOutLabel = buybarAdd.dataset.soldOutLabel || 'Tijdelijk uitverkocht';
      if (state === 'choose') {
        buybarAdd.disabled = false;
        buybarAdd.setAttribute('aria-disabled', 'false');
        setButtonText(buybarAdd, chooseLabel);
        return;
      }
      buybarAdd.disabled = !available;
      buybarAdd.setAttribute('aria-disabled', available ? 'false' : 'true');
      setButtonText(buybarAdd, available ? addLabel : soldOutLabel);
    }

    function setMobileAction(state) {
      const buybarVisible = state === 'buy' || state === 'choose';
      const adviceVisible = state === 'advice';
      const hasAction = buybarVisible || adviceVisible;
      root.dataset.mobileAction = state;
      root.classList.toggle('has-mobile-action', hasAction);
      root.classList.remove('has-mobile-product-cta', 'is-mobile-product-cta-visible');
      setAccessible(mobileBuybar, buybarVisible);
      setAccessible(adviceBar, adviceVisible);
      setBuybarMode(state);

      if (!hasAction) {
        root.style.removeProperty('--mobile-action-height');
        return;
      }

      const activeElement = adviceVisible ? adviceBar : mobileBuybar;
      if (!activeElement) return;
      const bottom = parseFloat(window.getComputedStyle(activeElement).bottom) || 0;
      root.style.setProperty('--mobile-action-height', Math.ceil(activeElement.offsetHeight + bottom + 8) + 'px');
    }

    function measureMobileAction() {
      measureQueued = false;
      const drawerOpen = root.classList.contains('is-drawer-open');
      if (!productSection.isConnected || !mobileQuery.matches || drawerOpen || !productPurchasable || !productForm || !originalAdd || !mobileBuybar || !buybarAdd) {
        setMobileAction('none');
        return;
      }

      const mainCtaPassed = originalAdd.getBoundingClientRect().bottom <= 0;
      if (!mainCtaPassed) {
        setMobileAction('none');
        return;
      }

      /* De losse resultaatbalk (state 'advice', #pw-plak) is vervangen door
         de adviesstrip ín de koopbalk — één balk, geen concurrentie.
         Zie plant-in-tuin.js (module "Deze plant in jouw tuin"). */

      if (variantPicker && (!variantExplicit || !variantAvailable())) {
        setMobileAction('choose');
        return;
      }

      setMobileAction(variantAvailable() ? 'buy' : 'none');
    }

    function queueMobileActionMeasure() {
      if (measureQueued) return;
      measureQueued = true;
      requestAnimationFrame(measureMobileAction);
    }

    if (variantPicker) {
      const markVariantExplicit = () => {
        variantExplicit = true;
        productSection.dataset.variantExplicit = 'true';
        queueMobileActionMeasure();
      };
      variantPicker.addEventListener('click', (event) => {
        const radio = event.target.closest('input[type="radio"]');
        if (event.isTrusted && radio && !radio.disabled) markVariantExplicit();
      });
      variantPicker.addEventListener('change', (event) => {
        if (event.isTrusted && event.target.matches('input[type="radio"], select')) markVariantExplicit();
        queueMobileActionMeasure();
      });
    }

    if (buybarAdd) {
      buybarAdd.addEventListener('click', (event) => {
        if (root.dataset.mobileAction !== 'choose' || !variantPicker) return;
        event.preventDefault();
        event.stopPropagation();
        variantPicker.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        const focusTarget = variantPicker.querySelector('[data-variant-compact-select]:not([disabled])') ||
          variantPicker.querySelector('input[type="radio"]:not([disabled])');
        window.setTimeout(() => {
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }, reducedMotion ? 0 : 300);
      });
    }

    window.addEventListener('imenhof:plantwijzer-update', (event) => {
      if (event.detail && event.detail.valid) adviceDismissed = false;
      queueMobileActionMeasure();
    });
    window.addEventListener('imenhof:plantwijzer-used', () => {
      adviceDismissed = true;
      queueMobileActionMeasure();
    });
    window.addEventListener('imenhof:plantwijzer-availability', queueMobileActionMeasure);
    window.addEventListener('imenhof:product-submit-state', queueMobileActionMeasure);

    const drawerObserver = new MutationObserver(queueMobileActionMeasure);
    drawerObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
    if (adviceBar) {
      const adviceObserver = new MutationObserver(queueMobileActionMeasure);
      adviceObserver.observe(adviceBar, { attributes: true, attributeFilter: ['data-advice-available', 'data-advice-valid'] });
    }

    window.addEventListener('scroll', queueMobileActionMeasure, { passive: true });
    window.addEventListener('resize', queueMobileActionMeasure, { passive: true });
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', queueMobileActionMeasure);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target && event.target.contains(productSection)) setMobileAction('none');
    });

    setMobileAction('none');
    measureMobileAction();
  }
})();
